import register from '../../../../global/js/registry';
export default register('o-fhw-search', () => import(/* webpackMode: "lazy" */ './o-fhw-search.controller'));
